import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useState, useEffect } from "react";
import { ViewType } from "@supabase/auth-ui-shared";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";
import { useSearchParams } from "react-router-dom";

export default function OwnerLogin() {
  const [loginType] = useState("owner");
  const [view, setView] = useState<ViewType>("sign_in");
  const [searchParams] = useSearchParams();
  useAuthRedirect(loginType, () => {});

  useEffect(() => {
    const token = searchParams.get("token");
    const type = searchParams.get("type");
    
    if (token && (type === "recovery" || type === "invite")) {
      console.log("Token detected:", type);
      setView("update_password");
    }
  }, [searchParams]);

  const authConfig = {
    supabaseClient: supabase,
    appearance: {
      theme: ThemeSupa,
      style: {
        button: {
          background: "rgb(59 130 246)",
          color: "white",
          borderRadius: "0.5rem",
        },
        anchor: {
          color: "rgb(59 130 246)",
          textDecoration: "none",
        },
        message: {
          color: "rgb(34 197 94)",
        },
      },
    },
    localization: {
      variables: {
        sign_in: {
          email_label: "Email",
          password_label: "Mot de passe",
          email_input_placeholder: "Votre email",
          password_input_placeholder: "Votre mot de passe",
          button_label: "Connexion Propriétaire",
          loading_button_label: "Connexion en cours...",
          social_provider_text: "Se connecter avec {{provider}}",
          link_text: "Vous avez déjà un compte ? Connectez-vous",
        },
        forgotten_password: {
          button_label: "Mot de passe oublié ?",
          email_label: "Email",
          password_label: "Nouveau mot de passe",
          email_input_placeholder: "Votre email",
          loading_button_label: "Envoi en cours...",
          confirmation_text:
            "Vérifiez vos emails pour réinitialiser votre mot de passe",
        },
        update_password: {
          password_label: "Nouveau mot de passe",
          password_input_placeholder: "Votre nouveau mot de passe",
          button_label: "Mettre à jour le mot de passe",
          confirmation_text: "Votre mot de passe a été mis à jour avec succès",
          loading_button_label: "Mise à jour en cours...",
        },
      },
    },
    providers: [],
    view: view,
    redirectTo: `${window.location.origin}/login-owner`,
  };

  return (
    <div className="flex min-h-screen">
      <div className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div className="text-center mb-8">
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
              {view === "update_password" 
                ? "Réinitialisation du mot de passe" 
                : "Connexion Propriétaire"}
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              {view === "update_password"
                ? "Définissez votre nouveau mot de passe"
                : "Accédez à votre espace propriétaire"}
            </p>
          </div>
          <div className="mt-8">
            <Auth {...authConfig} />
          </div>
        </div>
      </div>
      <div className="relative hidden w-0 flex-1 lg:block">
        <img
          className="absolute inset-0 h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1553413077-190dd305871c"
          alt="Entrepôt moderne avec des étagères de stockage bien organisées, illustrant la gestion efficace des stocks avec Sibystock"
        />
      </div>
    </div>
  );
}